import React from "react";
import { Flex, Stack, Text, Avatar } from "@mantine/core";
import { useCachedAvatar } from "../../hooks/useCachedAvatar";
import { getAvatarFallbackText } from "../../utils/publicAvatarUtils";
import colorsCustom from "../../designTokens/colorsCustom";

export const WriterInfo = ({
  profileImage,
  userID,
  username,
  name,
  sx,
  size = "default",
  showThreadsLink = true // 새로운 prop 추가
}) => {
  const { imageSrc, loading, error } = useCachedAvatar(userID, profileImage);
  
  // 사이즈 설정
  let avatarSize, textSize;
  switch (size) {
    case "small":
      avatarSize = 24; textSize = "md"; break;
    case "large":
      avatarSize = 40; textSize = "lg"; break;
    case "big":
      avatarSize = 48; textSize = "lg"; break;
    case "xl":
      avatarSize = 56; textSize = "xl"; break;
    default:
      avatarSize = 32; textSize = "md"; break;
  }

  const handleImageError = (event) => {
    console.warn(`⚠️ Avatar image error for user ${username}`);
    event.target.src = "";
    event.target.alt = getAvatarFallbackText(username);
  };

  const handleThreadsLinkClick = () => {
    const threadsUrl = `https://www.threads.net/@${username}`;
    window.open(threadsUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Flex
      direction={"row"}
      w={"fit-content"}
      align={"center"}
      gap={8}
      p={"4px 20px 4px 4px"}
      style={{
        border: `0.5px solid ${colorsCustom.ui.dark.subtle}`,
        borderRadius: 36,
        cursor: showThreadsLink ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        ...sx,
      }}
      onClick={showThreadsLink ? handleThreadsLinkClick : undefined}
      onMouseEnter={(e) => {
        if (showThreadsLink) {
          e.currentTarget.style.backgroundColor = colorsCustom.ui.dark.light;
          e.currentTarget.style.borderColor = colorsCustom.ui.dark.moderate;
        }
      }}
      onMouseLeave={(e) => {
        if (showThreadsLink) {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.borderColor = colorsCustom.ui.dark.subtle;
        }
      }}
    >
      <Avatar
        src={imageSrc}
        size={avatarSize}
        onError={handleImageError}
        radius="xl"
        style={{
          // filter: 'grayscale(0.85)'
        }}
      >
        {getAvatarFallbackText(username)}
      </Avatar>
      <Stack gap={8}>
        <Text size={textSize} lh={1} fw={800} c={colorsCustom.ui.dark.bold}>
          {username}
        </Text>
        <Text
          size={textSize}
          lh={1}
          lineClamp={1}
          c={colorsCustom.ui.dark.moderate}
          style={{
            maxWidth: '16ch',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {name}
        </Text>
      </Stack>
    </Flex>
  );
};